export default "__VITE_ASSET__mazaGxdg__"